export default {
	setup: {
		title: "Set up your temple's records",
		optionalTitle: "Optional records",
		progress: "{done} of {total} essential records",
		optionalProgress: "{done} of {total} optional records",
		next: "Next step: {item}",
		open: "Open",
		assistantHint: "Prefer some help? The assistant creates the records with you.",
		cta: "Set up with the assistant",
		dismiss: "Dismiss",
		items: {
			medium: "Mediums",
			linha_espiritual: "Spiritual Lines",
			guia: "Guides",
			tipo_atendimento: "Attendance Types",
			tipo_ritual: "Ritual Types",
			vincular_atendimento: "Link an attendance to the Ritual Type",
			ritual: "Ritual",
			orixa: "Orixás",
			funcao: "Functions",
			etapa_jornada: "Journey Stages",
		},
	},
	greeting: {
		morning: "Good morning",
		afternoon: "Good afternoon",
		evening: "Good evening",
	},
	activeRitual: {
		title: "Active Ritual",
		noRituals: "No active rituals",
		noRitualsHint: "Open a ritual to start calling tickets.",
		viewAll: "View rituals",
		loadError: "Failed to load active rituals",
		live: "Live",
		openSince: "Open since {time}",
		openSinceDate: "Open since {date}, {time}",
		elapsedHours: "{hours}h{minutes} ago",
		elapsedMinutes: "{minutes} min ago",
		elapsedDay: "{days} day ago",
		elapsedDays: "{days} days ago",
		progressLabel: "attended",
		pending: "In line",
		inProgress: "In attendance",
		completed: "Completed",
		noTickets: "No tickets issued yet",
	},
	birthdayWidget: {
		title: "Birthdays",
		noBirthdays: "No upcoming birthdays",
		today: "Today",
		tomorrow: "Tomorrow",
		inDays: "In {days} days",
	},
	kpi: {
		consultants: "Consultants",
		mediums: "Mediums",
		tickets: "Tickets",
	},
	charts: {
		weeklyConsultants: "New Consultants per Week",
		monthlyPersons: "Consultants per Month",
		monthlyTickets: "Tickets per Month",
		orixaDistribution: "Children per Orixá",
		noData: "No data for this period",
	},
	topConsultants: {
		title: "Most Active Consultants",
		noData: "No consultants with tickets",
	},
	upcomingRituals: {
		title: "Upcoming Scheduled",
		noRituals: "No scheduled rituals",
		viewAll: "View all",
	},
};
